import React, { Component } from 'react'
import Page from '@components/Page'
import styled from 'styled-components'
import { Tabs, Menu, Dropdown, Button, Select, Modal, Steps, Radio, Row, Col, DatePicker } from 'antd';
import I18n from '@src/i18n';
import SearchComponent from '@src/components/Default/Search/SearchComponent';
import Table from '@components/TableComponent';
import IPagination from '@interfaces/IPagination';
import ProcessManagementService from '@services/ProcessManagement';
import { LocalStorageKeys } from '@containers/App';
import NotificationComponent from '@src/helpers/_showNotifications';
import Item from 'antd/lib/list/Item';
import { StatusProcess } from '@src/helpers/Enums';
import { timingSafeEqual } from 'crypto';
import SelectableUnitUserComponent from '@components/SelectableUnitUserComponent';
import { IUser } from '@interfaces/IUser';
import UserService from '@services/UserService';
import AssignmentService from '@services/ehss/Assignment';
import ButtonComponent from '@components/Button';
import UserRadioSelect from '@components/userRadioSelectComponent';
import TicketServiceEhss from '@services/TicketServiceEhss';
import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor';
import PageWithoutTitle from '@components/PageWithoutTitle';
import TicketRequestsInterceptor from '@src/helpers/interceptors/TicketRequestInterceptor';
import { PillarNames } from '@interfaces/pillar';
import AppContext from '@services/Context';
import pt_BR from 'antd/lib/locale-provider/pt_BR';
import moment from 'moment';

const Step = Steps.Step;
const { Option } = Select;

interface PropType { }
type StateType = {
  search: any;
  data: any;
  selected: any;
  tableData: any;
  offset?: string;
  isLoading: boolean;
  loadingMoreFormflows?: boolean,
  status?: number,
  table: any;
  url: string;
  loadingTable: boolean;
  serverResponse: any;
  currentTicket: any;

  // Users
  showUserSelectModal: boolean;
  selectedUnit: string,

  searchAvailableUsers: string;
  searchSavedUsers: string;

  loadingAvailableUsers: boolean;
  loadingSavedUsers: boolean;

  availableUsersData: IUser[];
  savedUsersData: any[];
  availableUsersAmount: number;
  savedUsersAmount: number;
  loadingMoreAvailableUsers: boolean;
  loadingMoreSavedUsers: boolean;
  availableUsersCurOffset?: string;
  savedUsersCurOffset?: string;

  currentStep: number;
  showFilterModal: boolean;
  haveItemSelected: boolean;
  userSelectedAsAssigner: string;
  usersData: any;
  curUsersOffset?: string
  loadingUsersBySearch: boolean;
  searchUser: string;
  loadingDoneFilter: boolean;
  loadingMoreUsers: boolean;

  processesData: any;
  curProcessesOffset?: string;
  processFilterId?: string;
  defaultValue: any;
  deadline: any;
  visiblePopOver: boolean;
  overdue?: any
  tickedId: string;

}

const tableColumns = [{
  title: 'labels.process',
  dataIndex: 'label',
  key: 'label',
},
{
  title: 'processManagement.columns.process.executor',
  dataIndex: 'owners',
  key: 'owners',
},
{
  title: 'common.status',
  dataIndex: 'status',
  key: 'status',
},
{
  title: 'table.createdAt',
  dataIndex: 'createdAt',
  key: 'createdAt'
},
{
  title: 'table.startAt',
  dataIndex: 'startAt',
  key: 'startAt'
},
{
  title: 'label.deadline',
  dataIndex: 'overdueAt',
  key: 'overdueAt'
},
{
  title: 'button',
  dataIndex: 'action',
  key: 'action'
}

];

const tableColumnsLI = [
  {
    title: 'label.nameProcess',
    dataIndex: 'label',
    key: 'label',
  },
  {
    title: 'processManagement.columns.process.executor',
    dataIndex: 'owners',
    key: 'owners',
  },
  {
    title: 'common.status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: 'table.createdAt',
    dataIndex: 'createdAt',
    key: 'createdAt'
  },
  {
    title: 'table.startAt',
    dataIndex: 'startAt',
    key: 'startAt'
  },

];

const usersAvailableTableColumns = [
  {
    title: 'table.units.users.name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'table.units.users.username',
    dataIndex: 'username',
    key: 'username'
  },
  {
    title: '',
    dataIndex: 'loading',
    key: 'loading',
    width: "10%"
  }
];

const usersSavedTableColumns = [
  {
    title: 'table.units.users.name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'table.units.users.username',
    dataIndex: 'username',
    key: 'username'
  },
  {
    title: '',
    dataIndex: 'loading',
    key: 'loading',
    width: "10%"
  }
];

const _ProcessManagementService: ProcessManagementService = new ProcessManagementService();
const _formflowService: ProcessRequestsInterceptor = new ProcessRequestsInterceptor();
const _ticketService: TicketRequestsInterceptor = new TicketRequestsInterceptor();
// const defaultValue: any = JSON.parse(localStorage.getItem('clientDefault') || '');

export default class ProcessManagement extends Component<PropType, StateType> {

  private idUnit = ''
  private SelectableUserUnitRef: any;
  private _usersService: any;
  private currentPillar: string;

  constructor(props: PropType) {
    super(props);
    this.SelectableUserUnitRef = React.createRef();
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))
    this.currentPillar = String(localStorage.getItem(LocalStorageKeys.PILLAR))
    this._usersService = this.currentPillar === "EHSS" ? new AssignmentService() : new UserService;
    this.state = {
      search: '',
      data: [],
      selected: '',
      tableData: [],
      isLoading: false,
      status: undefined,
      table: [],
      url: '',
      loadingTable: false,
      currentTicket: undefined,

      serverResponse: undefined,
      showUserSelectModal: false,
      selectedUnit: '',

      searchAvailableUsers: '',
      searchSavedUsers: '',

      loadingAvailableUsers: false,
      loadingSavedUsers: false,

      availableUsersData: [],
      savedUsersData: [],
      availableUsersAmount: 0,
      savedUsersAmount: 0,
      loadingMoreAvailableUsers: false,
      loadingMoreSavedUsers: false,
      availableUsersCurOffset: undefined,
      savedUsersCurOffset: undefined,

      currentStep: 0,
      showFilterModal: false,
      haveItemSelected: false,
      userSelectedAsAssigner: '',
      usersData: [],
      loadingUsersBySearch: false,
      searchUser: '',
      loadingDoneFilter: false,
      loadingMoreUsers: false,

      processesData: [],
      processFilterId: '',
      defaultValue: JSON.parse(localStorage.getItem('clientDefault') || '{}'),
      deadline: undefined,
      visiblePopOver: false,
      tickedId: ''
    }
  }

  componentDidMount() {
    this.initialData()
  }

  initialData = async () => {
    await this.getProcessFilter(true, '')

    if (this.state.defaultValue.actionPlan) {
      const startProcess = await this.state.processesData.find((e: any) => e.id === this.state.defaultValue.actionPlan.processId)
      if (startProcess) {
        this.setState({ processFilterId: startProcess.id })
      } else {
        this.setState({ processFilterId: '' })
      }
    } else {
      this.setState({ processFilterId: this.state.defaultValue.actionPlan ? this.state.defaultValue.actionPlan.processId : this.state.processesData[0].id })
    }

    await this.getProcess(true, true);
  }

  toggleUserSelectModal = async (items?: any) => {

    if (this.state.showUserSelectModal === false) {
      this.getAvailableUsers(true, true);
      this.getSavedUsers(true, true);
    }
    this.setState({
      showUserSelectModal: !this.state.showUserSelectModal,
      // searchAvailableUsers: '',
      // searchSavedUsers: '',
    });
    this.setState({ selectedUnit: items.id || '', currentTicket: items })

  }

  formatHTML(label: any) {
    return { __html: label };
  }

  permissionApi = (accept: string[], roles: any) => {
    for (let a of accept) {
      if (roles.find((s: any) => s == a) != null) {
        return true
      }
    }
    return false
  }

  async getProcess(reset: boolean, showLoading?: boolean) {
    if (showLoading != undefined) { await this.setState({ isLoading: true }) };
    await this.setState({ loadingTable: true })

    if (reset) {
      await this.setState({
        offset: undefined
      });
    }

    const roles: any = JSON.parse(localStorage.getItem('roles') || '');

    try {
      // SE FOR ADMIN
      const params = {
        unit: this.idUnit,
        status: this.state.status,
        to: undefined,
        from: undefined,
        search: this.state.search,
        limit: 10,
        offset: this.state.offset,
        process: this.state.processFilterId,
        owner: this.state.userSelectedAsAssigner
      }

      let response: IPagination<any>;
      if (this.permissionApi(['ADMIN'], roles)) {
        response = await _ticketService.paging(params, this.state.processFilterId);
      } else {
        response = await _ticketService.pagingByRole(params);
      }
      let dataTableCreate: any = [];

      response.items.map(async (item: any) => {
        item = dataTableCreate.push({
          id: item.id,
          label: <div style={{ paddingTop: '1.5rem' }} dangerouslySetInnerHTML={this.formatHTML(item.label)} />,
          owners: item.owners,
          status: item.value ? item.value.status : 1,
          createdAt: item.createdAt,
          overdueAt: item.overdueAt || this.getSmatOverdueAt(item.value),
          modifiedAt: item.startAt,
          ticketId: item.ticketId,
          processId: item.workflowEvent.id,
          startAt: item.value ? item.value.startAt : '-',
        })

      })
      let newDataTableCreate: any = [];
      if (!reset) {
        newDataTableCreate = this.state.tableData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);
      await this.setState({
        tableData: newDataTableCreate,
        isLoading: false,
        offset: response.offset,
        loadingMoreFormflows: false,
        loadingTable: false
      });
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l('common.error'), e);
      await this.setState({ isLoading: false });
    }
  }
  getSmatOverdueAt(values: any){
    let dataNumber = values.results.find((res : any) => typeof res === 'number')
    return dataNumber
  }
  handleChange = (e: any) => {
    this.setState({
      search: e.event.target
    })
  }

  searchProcess = async (event: any) => {
    event.preventDefault();
    await this.setState({
      search: event.target.find.value,
      isLoading: true
    })
    if (event === '') {
      await this.setState({
        search: ''
      })
    }
    await this.setState({
      isLoading: true,
    })
    this.getProcess(true, true);
  }

  loadMoreProcess() {
    this.setState({ loadingMoreFormflows: true });
    this.getProcess(false);
  }

  handleDropDownClick = async (e: any) => {
    const value = parseInt(e)
    if (value !== 0) {
      this.setState({ status: e.target.value })
    }
    else {
      this.setState({ status: undefined })
    }
  }

  enumTranslator = (enumerator: any) => {
    switch (enumerator) {
      case '1':
        return I18n.l('processManagement.description.status')
      case '2':
        return I18n.l('global.taskflow.status.inprogress')
      case '3':
        return I18n.l('dashboard.dones')
      case '4':
        return I18n.l('common.error')
      case '5':
        return I18n.l('processManagement.search.overdue')
      case '6':
        return I18n.l('ProcessManagement.search.onHold')
      default:
        return I18n.l('auditeds.filter.button.text.all')


    }
  }

  getProcessFilter = async (reset: boolean, user?: string, filter?: boolean) => {
    if (reset) {
      this.setState({
        curProcessesOffset: undefined
      });
    }
    try {
      if (user != undefined) {
        if (this.idUnit) {

          const dataTableCreate: any = []

          const data: any = await _formflowService.paging({
            unit: this.idUnit,
            to: undefined,
            from: undefined,
            search: user,
            limit: 100,
            offset: this.state.curProcessesOffset
          },
            ['id', 'name']
          );

          let nextUsersData: any[] = [];

          if (!reset) {
            nextUsersData = this.state.processesData || [];
          }
          nextUsersData = nextUsersData.concat(data.items);
          this.setState({
            processesData: nextUsersData,
            curProcessesOffset: data.offset,

          });
        }
        else {
          throw new Error("No unit set");
        }
      }
      else {
        this.setState({
          processesData: [],
          curProcessesOffset: undefined,

        });
      }
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l('common.error'), error);
    }
  }

  onClickUpdatePage = async () => {
    await this.getProcess(true, true)
  }

  //#region TRANSFER USER
  onRemoveUser = async (userId: string) => {
    const { selectedUnit } = this.state;
    this.setLoadingSavedUserData(userId, true);

    const userObj = this.getUserSavedObject(userId);

    try {
      await _ProcessManagementService.ownerRemove(selectedUnit, userId);
      this.setLoadingSavedUserData(userId, false);

      this.userRemoved(userId, userObj);
    } catch (e) {
      this.setLoadingSavedUserData(userId, false);
      NotificationComponent.Notify('error', I18n.l("common.error"), e);
    }
  }

  userRemoved = async (id: string, userRemoved: any) => {
    const { availableUsersData, savedUsersData } = this.state;

    const newAvailableData: any[] = [...availableUsersData];
    newAvailableData.push(userRemoved);

    const userIndexToRemove = savedUsersData.findIndex((item: any) => item.id === id);
    let nextSavedData = [...savedUsersData];
    nextSavedData.splice(userIndexToRemove, 1);

    this.setState({
      savedUsersData: nextSavedData,
      availableUsersData: newAvailableData,
      savedUsersAmount: (this.state.savedUsersAmount - 1),
      availableUsersAmount: (this.state.availableUsersAmount + 1)
    });
    if (this.state.savedUsersData.length === 0 && this.state.savedUsersAmount > 0) {
      this.getSavedUsers(true, true);
    }
    await this.getProcess(true)

  }

  onAddUser = async (userId: string) => {

    const { selectedUnit } = this.state;
    this.setLoadingAvailableUserData(userId, true);
    const userObj = this.getUserAvailableObject(userId);

    try {
      await _ProcessManagementService.ownerAdd(selectedUnit, userId);
      this.setLoadingAvailableUserData(userId, false);
      this.userAdded(userId, userObj);

    } catch (e) {
      this.setLoadingAvailableUserData(userId, false);
      NotificationComponent.Notify('error', I18n.l("common.error"), e);
    }
  }

  userAdded = async (id: string, userToSave: any) => {
    const { availableUsersData, savedUsersData } = this.state;

    const newSaveData: any[] = [...savedUsersData];
    newSaveData.push(userToSave);

    const userIndexToRemove = availableUsersData.findIndex((item: any) => item.id === id);
    const nextAvailableData = [...availableUsersData];
    nextAvailableData.splice(userIndexToRemove, 1);

    this.SelectableUserUnitRef.current.saveAvailableUserDone();

    this.setState({
      availableUsersData: nextAvailableData,
      savedUsersData: newSaveData,
      savedUsersAmount: (this.state.savedUsersAmount + 1),
      availableUsersAmount: (this.state.availableUsersAmount - 1)
    });
    if (this.state.availableUsersData.length === 0 && this.state.availableUsersAmount > 0) {
      this.getAvailableUsers(true, true);
    }
    await this.getProcess(true)

    // this.setAuditsToUser();
  }

  getUserAvailableObject(id: string) {
    const { availableUsersData } = this.state;
    let user = undefined;

    user = availableUsersData.find((item: any) => item.id === id);

    return user;
  }

  getUserSavedObject(id: string) {
    const { savedUsersData } = this.state;
    let user = undefined;

    user = savedUsersData.find((item: any) => item.id === id);

    return user;
  }

  setLoadingAvailableUserData = async (userId: string, loading: boolean) => {
    const { availableUsersData } = this.state;

    const user: any = availableUsersData.find((item: any) => {
      return item.id === userId;
    });
    const indexOf = availableUsersData.indexOf(user);

    const newUsersData: any[] = [...availableUsersData];
    newUsersData[indexOf].loading = loading;
    newUsersData[indexOf].disabled = loading;

    this.setState({ availableUsersData: newUsersData });
  }

  setLoadingSavedUserData = async (userId: string, loading: boolean) => {
    const { savedUsersData } = this.state;

    const user: any = savedUsersData.find((item: any) => {
      return item.id === userId;
    });
    const indexOf = savedUsersData.indexOf(user);

    const newUsersData: any[] = [...savedUsersData];
    newUsersData[indexOf].loading = loading;

    this.setState({ savedUsersData: newUsersData });
  }

  onSearchAvailableUsers = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;
    this.setState({ searchAvailableUsers: SearchValue });

    this.getAvailableUsers(true, true);
  }

  onSearchSavedUsers = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;
    this.setState({ searchSavedUsers: SearchValue });

    this.getSavedUsers(true, true);
  }

  getAvailableUsers = async (reset: boolean, showLoading: boolean, loadingMore?: boolean) => {
    this.setState({
      loadingAvailableUsers: showLoading,
      loadingMoreAvailableUsers: (!!loadingMore ? loadingMore : false)
    });

    if (reset) {
      this.setState({
        availableUsersData: [],
        availableUsersCurOffset: undefined,
      });
    }

    try {
      const data: IPagination<IUser> = await this._usersService.paging({
        unit: this.idUnit,
        notUnit: this.state.selectedUnit,
        to: undefined,
        from: undefined,
        search: this.state.searchAvailableUsers,
        limit: 100,
        offset: this.state.availableUsersCurOffset,
      });

      const dataTableCreate: any[] = [];

      const loadingValue: boolean = false;
      let ownersIds: string[] = []
      for (let owner of this.state.currentTicket.owners) {
        ownersIds.push(owner.id)
      }

      data.items.map((item: any) => {
        if (!ownersIds.includes(item.id)) {
          dataTableCreate.push({
            id: item.id,
            name: item.name,
            username: item.username,
            loading: loadingValue,
          })
        }
      });

      let newDataTableCreate: any[] = [];
      if (!reset) {
        newDataTableCreate = this.state.availableUsersData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      this.setState({
        availableUsersData: newDataTableCreate,
        loadingAvailableUsers: false,
        availableUsersAmount: data.count,
        loadingMoreAvailableUsers: false,
        availableUsersCurOffset: data.offset,
      });
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      this.setState({
        loadingAvailableUsers: false,
        loadingMoreAvailableUsers: false,
      });
    }
  };

  getSavedUsers = async (reset: boolean, showLoading: boolean, loadingMore?: boolean) => {
    this.setState({
      loadingSavedUsers: showLoading,
      loadingMoreSavedUsers: (!!loadingMore ? loadingMore : false)
    });

    if (reset) {
      this.setState({
        savedUsersData: [],
        savedUsersCurOffset: undefined,
      });
    }

    try {
      const data: IPagination<IUser> = await this._usersService.paging({
        unit: this.state.selectedUnit,
        to: undefined,
        from: undefined,
        search: this.state.searchSavedUsers,
        limit: 100,
        offset: this.state.savedUsersCurOffset
      });

      const dataTableCreate: any[] = [];
      let ownersIds: string[] = []

      for (let owner of this.state.currentTicket.owners) {
        ownersIds.push(owner.id)
      }

      data.items.map(async (item: any) => {
        if (ownersIds.includes(item.id)) {
          dataTableCreate.push({
            name: item.name,
            username: item.username,
            id: item.id,
            loading: false,
          })
        }

      });

      let newDataTableCreate: any[] = [];
      if (!reset) {
        newDataTableCreate = this.state.savedUsersData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      this.setState({
        savedUsersData: newDataTableCreate,
        loadingSavedUsers: false,
        savedUsersAmount: data.count,
        loadingMoreSavedUsers: false,
        savedUsersCurOffset: data.offset,
      });

    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      this.setState({
        loadingSavedUsers: false,
        loadingMoreSavedUsers: false,
      });
    }
  };

  loadMoreAvailableUsers = () => {
    this.getAvailableUsers(false, false, true);
  }

  loadMoreSavedUsers = () => {
    this.getSavedUsers(false, false, true);
  }

  //#endregion

  getUsers = async (reset: boolean, user?: string) => {
    if (reset) {
      await this.setState({
        curUsersOffset: undefined
      });
    }
    try {
      if (user != undefined) {
        if (this.idUnit) {

          const dataTableCreate: any = []

          const data = await this._usersService.paging({
            unit: this.idUnit,
            to: undefined,
            from: undefined,
            search: user,
            disabled: false,
            noAssignment: true,
            limit: 6,
            offset: this.state.curUsersOffset
          });

          data.items.map((item: any, index: number) => {
            let _tableData = {
              key: index,
              id: item.id,
              name: item.name,
              username: item.username,
              email: item.email,
              phone: item.phone,
              createdAt: item.createdAt,
              disabled: item.disabled,
              fields: item.fields
            };

            dataTableCreate.push(_tableData);
          })

          let nextUsersData: any[] = [{ id: '', name: I18n.l('dashboard.allUsers') }];

          if (!reset) {
            nextUsersData = this.state.usersData || [];
          }
          nextUsersData = nextUsersData.concat(dataTableCreate);
          this.setState({
            usersData: nextUsersData,
            curUsersOffset: data.offset,
            // noUserFound: nextUsersData.length == 0,
            loadingMoreUsers: false,
            // usersAmount: data.count,
            loadingUsersBySearch: false,
          });
        }
        else {
          throw new Error("No unit set");
        }
      }
      else {
        this.setState({
          usersData: [],
          curUsersOffset: undefined,
          loadingMoreUsers: false,
          loadingUsersBySearch: false,
          // noUserFound: false,
        });
      }
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.searchUser"), error);
    }
  }

  toggleFilterModal = () => {
    this.getUsers(true, '')
    this.setState({
      showFilterModal: !this.state.showFilterModal,
      haveItemSelected: false,
      userSelectedAsAssigner: '',
      loadingDoneFilter: false,
      currentStep: 0
    });
  }

  handleUsersSearch = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;

    await this.setState({
      loadingUsersBySearch: true,
      searchUser: SearchValue,
    })
    try {
      this.getUsers(true, SearchValue);
    }
    catch (err) {
      console.log(err)
    }
  };
  onRadioItemSelectionChange = async (userId: string) => {
    await this.setState({
      haveItemSelected: !!userId,
      userSelectedAsAssigner: userId,
    });
  }

  loadMoreUsers = () => {
    this.setState({ loadingMoreUsers: true, });
    this.getUsers(false, this.state.searchUser);
  }

  renderAssignmentsStep = (): JSX.Element => {
    const { usersData, loadingUsersBySearch, searchUser, loadingMoreUsers } = this.state
    return (
      <div className='goepik-component-padding'>
        <SearchResponsible>
          <SearchComponent
            onSubmit={this.handleUsersSearch}
            placeholder='form.placeholders.alertsSearch'
            buttonText='form.buttons.search'
          />
        </SearchResponsible>

        {usersData.length > 0 && (
          <UserRadioSelect
            columns={usersAvailableTableColumns}
            data={usersData}
            itemSelectionChanged={(userId: string) => this.onRadioItemSelectionChange(userId)}
            loadingMoreData={loadingMoreUsers}
            hasMoreData={this.state.curUsersOffset != undefined && this.state.curUsersOffset != ''}
            onShowMore={this.loadMoreUsers}
            valueSelected={''}
            notScroll={true}
          >
          </UserRadioSelect>
        )}
        {usersData.length == 0 && loadingUsersBySearch === false && searchUser.length == 0 && (
          <p className="goepik-component-padding">{I18n.l('titles.noUserRegistered')}</p>
        )}
        {loadingUsersBySearch === true && (
          <p className="goepik-component-padding">{I18n.l('common.loadingTable')}</p>
        )}
        {(usersData && usersData.length === 0 && searchUser.length > 0 && loadingUsersBySearch == false) && (
          <p className="goepik-component-padding">{I18n.l('common.noResult')}</p>
        )}
        {searchUser.length == 0 && (
          <p className="goepik-component-padding"></p>
        )}
      </div>
    )
  }

  renderStatusStep = (): JSX.Element => {
    const { usersData } = this.state
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };
    return (
      <div className='goepik-component-padding'>
        <Radio.Group style={{ width: '20%' }} defaultValue={StatusProcess.ALL} onChange={this.handleDropDownClick}>
          <Radio style={radioStyle} value={StatusProcess.ALL}>{I18n.l('auditors.filter.button.label.all')}</Radio>
          <Radio style={radioStyle} value={StatusProcess.PENDENT}>{I18n.l('processManagement.description.status')}</Radio>
          <Radio style={radioStyle} value={StatusProcess.IN_PROGRESS}>{I18n.l('global.taskflow.status.inprogress')}</Radio>
          <Radio style={radioStyle} value={StatusProcess.DONE}>{I18n.l('dashboard.dones')}</Radio>
          <Radio style={radioStyle} value={StatusProcess.ERROR}>{I18n.l('common.error')}</Radio>
          <Radio style={radioStyle} value={StatusProcess.OVERDUE}>{I18n.l('processManagement.search.overdue')}</Radio>
          <Radio style={radioStyle} value={StatusProcess.WAIT}>{I18n.l('ProcessManagement.search.onHold')}</Radio>
        </Radio.Group>
      </div>
    )
  }

  onClickFilter = async () => {
    await this.setState({ loadingDoneFilter: true })
    await this.getProcess(true)
    await this.toggleFilterModal()
  }

  renderAuditModal = (): JSX.Element => {

    const steps = [{
      title: I18n.l("form.titles.selectAssignment"),
      content: this.renderAssignmentsStep(),
    }, {
      title: I18n.l("form.titles.selectStatus"),
      content: this.renderStatusStep(),
    }];

    return (
      <Modal width={800} onCancel={this.toggleFilterModal} visible={this.state.showFilterModal} footer={false}>
        <ModalTitle>{I18n.l('common.filterBy')}</ModalTitle>
        <ModalContent>
          <Steps current={this.state.currentStep}>
            {steps.map(item => <Step key={item.title} title={item.title} />)}
          </Steps>
          <div className="steps-content" style={{ position: "relative" }}>
            {steps[this.state.currentStep].content}
            {/* {this.state.currentStep > 0 && (
              <ButtonComponent className="link primary bolder bottomAlign" onClick={() => this.prevStep()}>{I18n.l('common.previous')}</ButtonComponent>
            )} */}
          </div>
          <div className="steps-action" style={{ textAlign: 'right' }} >
            {this.state.currentStep > 0 && (
              <Button style={{ marginRight: 8 }} onClick={() => this.prevStep()}>
                {I18n.l('common.previous')}
              </Button>
            )}
            {this.state.currentStep < steps.length - 1 && (
              <Button type="primary" onClick={() => this.nextStep()}>
                {I18n.l('common.next')}
              </Button>
            )}
            {this.state.currentStep === steps.length - 1 && (
              <Button loading={this.state.loadingDoneFilter ? true : false} type="primary" onClick={this.onClickFilter}>
                {I18n.l('common.finish')}
              </Button>
            )}

          </div>
        </ModalContent>
      </Modal>
    );
  }

  //#region STEPS
  nextStep() {
    const currentStep = this.state.currentStep + 1;
    this.setState({ currentStep });
  }

  prevStep() {
    const currentStep = this.state.currentStep - 1;
    this.setState({ currentStep });
  }

  //#endregion

  getOptionsProcess() {
    let options: JSX.Element[] = []
    if (this.state.processesData.length > 0) {
      for (let items of this.state.processesData) {
        options.push(
          <Option key={items.id} value={items.id}>{items.name}</Option>
        )
      }
    }
    return options;
  }

  onChangeSelectProcess = async (evt: any) => {
    this.setState({ processFilterId: evt })
    this.getProcess(true, true);
  }

  onClickPopover = async (item: any) => {
    this.setState({ tickedId: item.id })
    if (item.overdueAt) {

      this.setState({
        deadline: 1,
        overdue: item.overdueAt
      })
    }
    else {
      this.setState({
        deadline: 0,
        overdue: undefined
      })
    }
  }

  editDeadline = async (overdue: any, deadline: any) => {
    const newTableData = Object.assign(this.state.tableData)
    let newOverdue
    if (deadline === 1) newOverdue = overdue
    else newOverdue = 0
    try {
      const idxTicket = newTableData.findIndex((e: any) => e.id === this.state.tickedId)
      newTableData[idxTicket].overdueAt = newOverdue
      this.setState({ tableData: this.state.tableData })
      await _ProcessManagementService.overdueEdit(this.state.tickedId, newOverdue)

    } catch (error) {
      console.warn(error)
    }
  }

  render() {
    const TabPane = Tabs.TabPane

    const {
      serverResponse,

      showUserSelectModal,
      loadingAvailableUsers,
      loadingSavedUsers,
      savedUsersData,
      availableUsersData,

      searchAvailableUsers,
      searchSavedUsers,
      availableUsersAmount,
      savedUsersAmount,
      loadingMoreAvailableUsers,
      loadingMoreSavedUsers
    } = this.state
    return (
      <PageWithoutTitle>
        <div style={{ paddingBottom: '3rem' }}>
          <span style={{ color: 'black', fontSize: '48px', fontWeight: 'bold' }} >
            {this.currentPillar === 'EHSS' && I18n.l('routes.processManagement')} {this.currentPillar !== 'EHSS' && I18n.l('labels.processmanagement')}
          </span>
        </div>
        <Wrapper>
          <div style={{ width: '100%' }}>
            <Row>
              {/* {this.state.processFilterId !== '' && */}
              <Col sm={5} md={5} xl={5} style={{ paddingRight: '1rem' }}>
                <Select
                  defaultValue={this.state.processFilterId}
                  size="large"
                  placeholder={I18n.l("auditconf.processSelectPlaceholder")}
                  style={{ width: '100%' }}
                  onChange={this.onChangeSelectProcess}>
                  <Option value={''}>{I18n.l("label.allProcess")}</Option>
                  {this.getOptionsProcess()}
                </Select>
              </Col>
              {/* } */}
              <Col sm={18} md={18} xl={18}>
                <SearchComponent
                  onSubmit={this.searchProcess}
                  placeholder='process.search'
                  defaultValue={this.state.search}
                  buttonText='form.buttons.search'
                />
              </Col>
            </Row>

            <div className="filter">
              {/* <Button
                type='primary'
                style={{ marginLeft: '1rem', width: '150px', fontWeight: 'bold' }}
                onClick={this.onClickUpdatePage}
              >
                {I18n.l('common.update')}
              </Button> */}
              {this.state.showFilterModal && (
                this.renderAuditModal()
              )}
              <Button
                type='primary'
                style={{  fontWeight: 'bold', margin: '30px 30px 30px 0' }}
                onClick={this.toggleFilterModal}
              >
                {this.currentPillar === "EHSS" &&
                  I18n.l('commom.filterByResponsable')
                }
                {this.currentPillar !== "EHSS" &&
                  I18n.l('commom.filterByUsers')
                }
              </Button>
            </div>

            {(this.state.isLoading) &&
              <span>{I18n.l('common.loadingData')}</span>
            }
            {this.state.processFilterId === undefined &&
              <span>{I18n.l('labels.noProcessRegister')}</span>
            }
            {(!this.state.isLoading && this.state.processFilterId !== undefined) &&
              <Table
                columns={this.currentPillar !== PillarNames.LI ? tableColumns : tableColumnsLI}
                data={this.state.tableData}
                noPagination={true}
                showConfirmationModal={false}
                url={true}
                status={true}
                onLink={this.toggleUserSelectModal}
                onClickPopover={this.onClickPopover}
                // popoverContent={() => this.popoverContent()}
                // visiblePopover={this.state.visiblePopOver}
                // handleVisiblePopover={this.handleVisiblePopover}
                editDeadline={this.editDeadline}
              />
            }
            {this.state.offset && (
              <Button
                className="loading-more"
                type="primary"
                size='large'
                ghost
                loading={this.state.loadingMoreFormflows}
                onClick={() => this.loadMoreProcess()}>{I18n.l('common.seeMore')}</Button>
            )}
          </div>
          {showUserSelectModal && (
            <SelectableUnitUserComponent
              title={
                I18n.l('form.titles.transferUser')
              }
              showModal={showUserSelectModal}
              onToggleFormModal={() => this.toggleUserSelectModal(undefined)}
              serverResponse={serverResponse}
              onItemRemoved={this.onRemoveUser}
              onItemSelected={this.onAddUser}

              loadingAvailableData={loadingAvailableUsers}
              loadingSavedData={loadingSavedUsers}

              usersAvailableData={availableUsersData}
              usersSavedData={savedUsersData}
              usersAvailableTableColumns={usersAvailableTableColumns}
              usersSavedTableColums={usersSavedTableColumns}

              onSearchAvailableUsers={this.onSearchAvailableUsers}
              onSearchSavedUsers={this.onSearchSavedUsers}
              searchAvailableUsersValue={searchAvailableUsers}
              searchSavedUsersValue={searchSavedUsers}

              showMoreAvailableData={this.state.availableUsersCurOffset != undefined && this.state.availableUsersCurOffset != ''}
              showMoreSavedData={this.state.savedUsersCurOffset != undefined && this.state.savedUsersCurOffset != ''}
              onLoadMoreAvailableData={this.loadMoreAvailableUsers}
              onLoadMoreSavedData={this.loadMoreSavedUsers}
              loadingMoreAvailableData={loadingMoreAvailableUsers}
              loadingMoreSavedData={loadingMoreSavedUsers}

              ref={this.SelectableUserUnitRef}
            />
          )}
        </Wrapper>
      </PageWithoutTitle>
    )
  }
}


const Wrapper = styled.div`
            display: flex;
            flex-flow: column;
            align-items: flex-start;
            justify-content: flex-start;
            width: 85vw;

            .filter{
              display: block;
            }`;

const SearchResponsible = styled.div`
    .search-component {
        max-width: 100% !important
    }
`;
const ModalTitle = styled.h3`
   font-size: 22px;
 `;

const ModalContent = styled.div`
 width: 100%;
                    
 .form-item-title{
   font-weight: bold;
   color:#333;
 }
 .form-item-error{
   color: #f00;
   margin-bottom:0px;
 }
                    
 .bottomAlign {
   position: absolute;
   bottom: 13px;
 }`;


